import { Grid, Typography } from "@mui/material";
import Component from "components/Component";
import AdminDashboard from "components/admin/AdminDashboard";
import SubmissionAccessEditor from "components/admin/SubmissionAccessEditor";
import UserSelector from "components/admin/UserSelector";
import DashboardContent from "components/layout/DashboardContent";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  useGetUserWhitelistListQuery,
  useGetUserWhitelistQuery,
} from "services/adminService";

const SubmissionAccessManager = () => {
  const { companyId } = useParams();
  const [selectedUser, setSelectedUser] = useState(null);

  const {
    data: whitelist,
    refetch: refetchWhitelist,
    isFetching: loadingWhitelist,
    isError: loadError,
  } = useGetUserWhitelistQuery(
    { userId: selectedUser?.username },
    { skip: !selectedUser?.username }
  );

  const {
    data: whitelistList,
    refetch: refetchWhitelistList,
    isFetching: loadingWhitelistList,
    isError: loadErrorList,
  } = useGetUserWhitelistListQuery(
    { userId: selectedUser?.username },
    { skip: !selectedUser?.username }
  );

  return (
    <div className={"app"}>
      <AdminDashboard>
        <DashboardContent>
          <Component title={"Submissions Access"}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <UserSelector
                  companyId={companyId}
                  value={selectedUser}
                  onChange={setSelectedUser}
                  showCopyId
                  sx={{ width: "30em" }}
                />
              </Grid>
              <Grid item xs={12}>
                {selectedUser ? (
                  <SubmissionAccessEditor
                    userId={selectedUser?.username}
                    whitelist={whitelist}
                    loadingWhitelist={loadingWhitelist}
                    loadError={loadError}
                    whitelistList={whitelistList}
                    loadingWhitelistList={loadingWhitelistList}
                    loadErrorList={loadErrorList}
                    onReload={() => {
                      refetchWhitelist();
                      refetchWhitelistList();
                    }}
                  />
                ) : (
                  <Typography variant={"body2"} color={"text.secondary"}>
                    {
                      "Select a user to view and edit their submission whitelist."
                    }
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Component>
        </DashboardContent>
      </AdminDashboard>
    </div>
  );
};

export default SubmissionAccessManager;
